var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSteadySupply = function SvgSteadySupply(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M59.25 9h-20a7 7 0 0 0-5.35 2.5h-6a6.49 6.49 0 0 0-5.1 2.5h-3.05a6 6 0 0 0-6 6v40a6 6 0 0 0 6 6h3.05a6.49 6.49 0 0 0 5.12 2.5h6a7 7 0 0 0 5.33 2.5h20a7 7 0 0 0 7-7V16a7 7 0 0 0-7-7m-39.5 55a4 4 0 0 1-4-4V20a4 4 0 0 1 4-4h2a6.6 6.6 0 0 0-.31 2v44a6.6 6.6 0 0 0 .31 2Zm8.17 2.5a4.51 4.51 0 0 1-4.5-4.5V18a4.51 4.51 0 0 1 4.5-4.5h4.8a6.9 6.9 0 0 0-.47 2.5v48a6.9 6.9 0 0 0 .47 2.5ZM64.25 64a5 5 0 0 1-5 5h-20a5 5 0 0 1-5-5V16a5 5 0 0 1 5-5h20a5 5 0 0 1 5 5Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49.25,
    cy: 60,
    r: 2,
    fill: "currentColor"
  })));
};
export default SvgSteadySupply;